import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '@raas/shared/src/components/minimals/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('@raas/shared/src/pages/LoginPage')));

export const LandingPageOverviewPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/landing-page/LandingPageOverview'))
);

export const LegalProvisionDetailsPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionDetailsPage'))
);

export const LegalProvisionRequestPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionRequestPage'))
);
export const LegalProvisionEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionEditPage'))
);
export const DocumentElementCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/document-element/DocumentElementCreatePage'))
);
export const DocumentElementEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/regulation-element/RegulationElementEditPage'))
);
export const DocumentElementViewPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/regulation-element/RegulationElementViewPage'))
);

export const TagGroupListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupListPage'))
);
export const TagGroupCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupCreatePage'))
);
export const TagGroupEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupEditPage'))
);

export const TagListPage = Loadable(lazy(() => import('@raas/shared/src/pages/tag/TagListPage')));
export const TagCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag/TagCreatePage'))
);
export const TagEditPage = Loadable(lazy(() => import('@raas/shared/src/pages/tag/TagEditPage')));

export const DeltaPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/delta/DeltaLegalProvisionPage'))
);

export const UserChangePassword = Loadable(
  lazy(() => import('@raas/shared/src/pages/user/Account'))
);

export const Page404 = Loadable(lazy(() => import('@raas/shared/src/pages/Page404')));

export const ExportsListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/exports/ExportsListPage'))
);

export const ExportsEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/exports/ExportsEditPage'))
);

export const LegalRequirementListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementListPage'))
);

export const LegalRequirementCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementCreatePage'))
);

export const LegalRequirementEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementEditPage'))
);

export const AlertsListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/alerts/AlertsListPage'))
);

export const AlertsEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/alerts/AlertsEditPage'))
);

export const LegalProvisionWithTranslationPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionWithTranslationPage'))
);

export const SignUpPage = Loadable(lazy(() => import('@raas/shared/src/pages/user/SignUp')));

export const IntegrationPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/integration/IntegrationPage'))
);

export const UserProfilePage = Loadable(
  lazy(() => import('@raas/shared/src/common/pages/UserProfilePage'))
);

export const BundlingListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/bundling/pages/BundlingListPage'))
);

export const AttributeListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/attribute/pages/AttributeListPage'))
);

// regulations
export const RegulationListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationListPage'))
);

export const RegulationContentPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationContentPage'))
);

export const RegulationPropertyListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationPropertyListPage'))
);
